export default __webpack_public_path__ + "static/img-2-4b53d0b5fcdc6f12bc2f52ba6ab272d2.png";